export default "__VITE_ASSET__56e26c9f__"